import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _632e38b8 = () => interopDefault(import('../pages/zapis/success.vue' /* webpackChunkName: "pages/zapis/success" */))
const _d69ef906 = () => interopDefault(import('../pages/zapis/error.vue' /* webpackChunkName: "pages/zapis/error" */))
const _01370f42 = () => interopDefault(import('../pages/zapis/_slug/index.vue' /* webpackChunkName: "pages/zapis/_slug/index" */))
const _50ea6547 = () => interopDefault(import('../pages/zapis/index.vue' /* webpackChunkName: "pages/zapis/index" */))
const _42f750b8 = () => interopDefault(import('../pages/wishlist.vue' /* webpackChunkName: "pages/wishlist" */))
const _57ed5aaf = () => interopDefault(import('../pages/video/index.vue' /* webpackChunkName: "pages/video/index" */))
const _90d0caf0 = () => interopDefault(import('../pages/vakansii/index.vue' /* webpackChunkName: "pages/vakansii/index" */))
const _7411a8e6 = () => interopDefault(import('../pages/uslugi/_slug/index.vue' /* webpackChunkName: "" */))
const _3b9209eb = () => interopDefault(import('../pages/uslugi/index.vue' /* webpackChunkName: "pages/uslugi/index" */))
const _40d44510 = () => interopDefault(import('../pages/stat/_category/_article/index.vue' /* webpackChunkName: "pages/stat/_category/_article/index" */))
const _dd39c778 = () => interopDefault(import('../pages/stat/_category/index.vue' /* webpackChunkName: "pages/stat/_category/index" */))
const _49bf1876 = () => interopDefault(import('../pages/stat/index.vue' /* webpackChunkName: "pages/stat/index" */))
const _48cc7d44 = () => interopDefault(import('../pages/specialists/components/SpecialistCard.vue' /* webpackChunkName: "pages/specialists/components/SpecialistCard" */))
const _d921995a = () => interopDefault(import('../pages/specialists/components/Header/SpecialistHeader.vue' /* webpackChunkName: "pages/specialists/components/Header/SpecialistHeader" */))
const _3090ffd4 = () => interopDefault(import('../pages/specialists/index.vue' /* webpackChunkName: "" */))
const _0696d924 = () => interopDefault(import('../pages/search/components/Articles.vue' /* webpackChunkName: "pages/search/components/Articles" */))
const _5ab2790a = () => interopDefault(import('../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _802168f2 = () => interopDefault(import('../pages/reviews/AddReviewModal.vue' /* webpackChunkName: "pages/reviews/AddReviewModal" */))
const _75c6600f = () => interopDefault(import('../pages/reviews/index.vue' /* webpackChunkName: "pages/reviews/index" */))
const _6b70099b = () => interopDefault(import('../pages/registration/index.vue' /* webpackChunkName: "pages/registration/index" */))
const _58100e09 = () => interopDefault(import('../pages/questions-specialist/_question/index.vue' /* webpackChunkName: "pages/questions-specialist/_question/index" */))
const _8a13e4da = () => interopDefault(import('../pages/questions-specialist/index.vue' /* webpackChunkName: "pages/questions-specialist/index" */))
const _7cf84fe1 = () => interopDefault(import('../pages/profile/zapis/index.vue' /* webpackChunkName: "pages/profile/zapis/index" */))
const _74634b62 = () => interopDefault(import('../pages/profile/my-acuvue/index.vue' /* webpackChunkName: "pages/profile/my-acuvue/index" */))
const _0c982ed2 = () => interopDefault(import('../pages/profile/edit/index.vue' /* webpackChunkName: "pages/profile/edit/index" */))
const _3d79bf42 = () => interopDefault(import('../pages/profile/discount-card/get-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/get-card/index" */))
const _724f7a7a = () => interopDefault(import('../pages/profile/discount-card/_guid/index.vue' /* webpackChunkName: "pages/profile/discount-card/_guid/index" */))
const _0521feac = () => interopDefault(import('../pages/profile/discount-card/index.vue' /* webpackChunkName: "pages/profile/discount-card/index" */))
const _05f7bf04 = () => interopDefault(import('../pages/profile/certificates/index.vue' /* webpackChunkName: "pages/profile/certificates/index" */))
const _39609aca = () => interopDefault(import('../pages/profile/bonuses/index.vue' /* webpackChunkName: "pages/profile/bonuses/index" */))
const _6f29dc1d = () => interopDefault(import('../pages/profile/index.vue' /* webpackChunkName: "pages/profile/index" */))
const _33412d91 = () => interopDefault(import('../pages/product/test.vue' /* webpackChunkName: "pages/product/test" */))
const _98b44b9e = () => interopDefault(import('../pages/product/glassesCardPage_v2.vue' /* webpackChunkName: "pages/product/glassesCardPage_v2" */))
const _4c039e9b = () => interopDefault(import('../pages/product/_slug.vue' /* webpackChunkName: "pages/product/_slug" */))
const _11d4cc99 = () => interopDefault(import('../pages/checkout/success.vue' /* webpackChunkName: "" */))
const _b97fd97e = () => interopDefault(import('../pages/order/payment/cancel/_hash.vue' /* webpackChunkName: "pages/order/payment/cancel/_hash" */))
const _bd8e86d8 = () => interopDefault(import('../pages/order/payment/_hash.vue' /* webpackChunkName: "pages/order/payment/_hash" */))
const _6963cf63 = () => interopDefault(import('../pages/checkout/process/_hash.vue' /* webpackChunkName: "" */))
const _4beb8a98 = () => interopDefault(import('../pages/ochki/_category/index.vue' /* webpackChunkName: "pages/ochki/_category/index" */))
const _029482e6 = () => interopDefault(import('../pages/ochki/index.vue' /* webpackChunkName: "pages/ochki/index" */))
const _d08c648e = () => interopDefault(import('../pages/miopiya/indexOriginal.vue' /* webpackChunkName: "pages/miopiya/indexOriginal" */))
const _213b9224 = () => interopDefault(import('../pages/miopiya/components/QRList.vue' /* webpackChunkName: "pages/miopiya/components/QRList" */))
const _61ea802a = () => interopDefault(import('../pages/miopiya/components/MiopiyaReasons.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaReasons" */))
const _5fc0aef6 = () => interopDefault(import('../pages/miopiya/components/MiopiyaPrevention.vue' /* webpackChunkName: "pages/miopiya/components/MiopiyaPrevention" */))
const _7227f048 = () => interopDefault(import('../pages/miopiya/index.vue' /* webpackChunkName: "pages/miopiya/index" */))
const _1ea5f5de = () => interopDefault(import('../pages/lenses/competitors/_slug.vue' /* webpackChunkName: "pages/lenses/competitors/_slug" */))
const _726f2b48 = () => interopDefault(import('../pages/lenses/_category/index.vue' /* webpackChunkName: "pages/lenses/_category/index" */))
const _0bb2a48e = () => interopDefault(import('../pages/lenses/index.vue' /* webpackChunkName: "pages/lenses/index" */))
const _fe834b56 = () => interopDefault(import('../pages/information_message/informationMessage.vue' /* webpackChunkName: "pages/information_message/informationMessage" */))
const _064b3e09 = () => interopDefault(import('../pages/get-card/index.vue' /* webpackChunkName: "pages/get-card/index" */))
const _96c4defc = () => interopDefault(import('../pages/company/questions/page.vue' /* webpackChunkName: "pages/company/questions/page" */))
const _5ff0c3f8 = () => interopDefault(import('../pages/company/questions/letterModal.vue' /* webpackChunkName: "pages/company/questions/letterModal" */))
const _73aa2bb0 = () => interopDefault(import('../pages/cms-page-preview/index.vue' /* webpackChunkName: "pages/cms-page-preview/index" */))
const _6c69ad16 = () => interopDefault(import('../pages/checkout/process/new.vue' /* webpackChunkName: "pages/checkout/process/new" */))
const _2b0783c8 = () => interopDefault(import('../pages/checkout/process/index.vue' /* webpackChunkName: "pages/checkout/process/index" */))
const _22367d68 = () => interopDefault(import('../pages/checkout/index.vue' /* webpackChunkName: "pages/checkout/index" */))
const _163f78e2 = () => interopDefault(import('../pages/charity/_category/_article/index.vue' /* webpackChunkName: "pages/charity/_category/_article/index" */))
const _ccc9bccc = () => interopDefault(import('../pages/charity/_category/index.vue' /* webpackChunkName: "pages/charity/_category/index" */))
const _12a7b14c = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _907dd132 = () => interopDefault(import('../pages/catalog/components/SelectedFilter.vue' /* webpackChunkName: "pages/catalog/components/SelectedFilter" */))
const _5e5eed1f = () => interopDefault(import('../pages/catalog/components/FilterMobileComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterMobileComponent" */))
const _570acfa1 = () => interopDefault(import('../pages/catalog/components/FilterComponent.vue' /* webpackChunkName: "pages/catalog/components/FilterComponent" */))
const _ca9c16ba = () => interopDefault(import('../pages/catalog/components/ContactLinzCategory.vue' /* webpackChunkName: "pages/catalog/components/ContactLinzCategory" */))
const _555731e2 = () => interopDefault(import('../pages/catalog/components/ArticleCard.vue' /* webpackChunkName: "pages/catalog/components/ArticleCard" */))
const _7a6f391a = () => interopDefault(import('../pages/catalog/_.vue' /* webpackChunkName: "pages/catalog/_" */))
const _7f9532e6 = () => interopDefault(import('../pages/catalog/index.vue' /* webpackChunkName: "pages/catalog/index" */))
const _f2e75e32 = () => interopDefault(import('../pages/cart_old.vue' /* webpackChunkName: "pages/cart_old" */))
const _6a866206 = () => interopDefault(import('../pages/cart/checkout.vue' /* webpackChunkName: "pages/cart/checkout" */))
const _47495c28 = () => interopDefault(import('../pages/cart-old/done.vue' /* webpackChunkName: "pages/cart-old/done" */))
const _7c1b2cb0 = () => interopDefault(import('../pages/cart-old/basketPageThirdStep.vue' /* webpackChunkName: "pages/cart-old/basketPageThirdStep" */))
const _288f084a = () => interopDefault(import('../pages/cart-old/basketPageSecondStep.vue' /* webpackChunkName: "pages/cart-old/basketPageSecondStep" */))
const _124aed1c = () => interopDefault(import('../pages/cart-old/index.vue' /* webpackChunkName: "pages/cart-old/index" */))
const _0a16037c = () => interopDefault(import('../pages/cart/index.vue' /* webpackChunkName: "pages/cart/index" */))
const _e5bcf752 = () => interopDefault(import('../pages/bystraya-zapis/index.vue' /* webpackChunkName: "pages/bystraya-zapis/index" */))
const _48d4d82d = () => interopDefault(import('../pages/authorization/index.vue' /* webpackChunkName: "pages/authorization/index" */))
const _d83dc0c0 = () => interopDefault(import('../pages/appointment/appointment.vue' /* webpackChunkName: "pages/appointment/appointment" */))
const _9095c7b4 = () => interopDefault(import('../pages/aktsii/_slug/index.vue' /* webpackChunkName: "pages/aktsii/_slug/index" */))
const _0e9ced2b = () => interopDefault(import('../pages/aktsii/index.vue' /* webpackChunkName: "pages/aktsii/index" */))
const _654df5e4 = () => interopDefault(import('../pages/acuvue/phoneRegistrationForm.vue' /* webpackChunkName: "pages/acuvue/phoneRegistrationForm" */))
const _142d2496 = () => interopDefault(import('../pages/acuvue/index.vue' /* webpackChunkName: "pages/acuvue/index" */))
const _a4fd18e0 = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/zapis/success",
    component: _632e38b8,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-success"
  }, {
    path: "/zapis/error",
    component: _d69ef906,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-error"
  }, {
    path: "/zapis/:slug",
    component: _01370f42,
    pathToRegexpOptions: {"strict":true},
    name: "zapis-slug"
  }, {
    path: "/zapis",
    component: _50ea6547,
    pathToRegexpOptions: {"strict":true},
    name: "zapis"
  }, {
    path: "/wishlist",
    component: _42f750b8,
    pathToRegexpOptions: {"strict":true},
    name: "wishlist"
  }, {
    path: "/video",
    component: _57ed5aaf,
    pathToRegexpOptions: {"strict":true},
    name: "video"
  }, {
    path: "/vakansii",
    component: _90d0caf0,
    pathToRegexpOptions: {"strict":true},
    name: "vakansii"
  }, {
    path: "/uslugi/:slug/:service",
    components: {
      default: _7411a8e6
    }
  }, {
    path: "/uslugi/:slug",
    component: _7411a8e6,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi-slug"
  }, {
    path: "/uslugi",
    component: _3b9209eb,
    pathToRegexpOptions: {"strict":true},
    name: "uslugi"
  }, {
    path: "/stat/:category/:article",
    component: _40d44510,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category-article"
  }, {
    path: "/stat/:category",
    component: _dd39c778,
    pathToRegexpOptions: {"strict":true},
    name: "stat-category"
  }, {
    path: "/stat",
    component: _49bf1876,
    pathToRegexpOptions: {"strict":true},
    name: "stat"
  }, {
    path: "/specialists/components/SpecialistCard",
    component: _48cc7d44,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-SpecialistCard"
  }, {
    path: "/specialists/components/Header/SpecialistHeader",
    component: _d921995a,
    pathToRegexpOptions: {"strict":true},
    name: "specialists-components-Header-SpecialistHeader"
  }, {
    path: "/specialists/:id",
    components: {
      default: _3090ffd4
    }
  }, {
    path: "/specialists",
    component: _3090ffd4,
    pathToRegexpOptions: {"strict":true},
    name: "specialists"
  }, {
    path: "/search/components/Articles",
    component: _0696d924,
    pathToRegexpOptions: {"strict":true},
    name: "search-components-Articles"
  }, {
    path: "/search",
    component: _5ab2790a,
    pathToRegexpOptions: {"strict":true},
    name: "search"
  }, {
    path: "/reviews/AddReviewModal",
    component: _802168f2,
    pathToRegexpOptions: {"strict":true},
    name: "reviews-AddReviewModal"
  }, {
    path: "/reviews",
    component: _75c6600f,
    pathToRegexpOptions: {"strict":true},
    name: "reviews"
  }, {
    path: "/registration",
    component: _6b70099b,
    pathToRegexpOptions: {"strict":true},
    name: "registration"
  }, {
    path: "/questions-specialist/:question",
    component: _58100e09,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist-question"
  }, {
    path: "/questions-specialist",
    component: _8a13e4da,
    pathToRegexpOptions: {"strict":true},
    name: "questions-specialist"
  }, {
    path: "/profile/zapis",
    component: _7cf84fe1,
    pathToRegexpOptions: {"strict":true},
    name: "profile-zapis"
  }, {
    path: "/profile/my-acuvue",
    component: _74634b62,
    pathToRegexpOptions: {"strict":true},
    name: "profile-my-acuvue"
  }, {
    path: "/profile/edit",
    component: _0c982ed2,
    pathToRegexpOptions: {"strict":true},
    name: "profile-edit"
  }, {
    path: "/profile/discount-card/get-card",
    component: _3d79bf42,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-get-card"
  }, {
    path: "/profile/discount-card/:guid",
    component: _724f7a7a,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card-guid"
  }, {
    path: "/profile/discount-card",
    component: _0521feac,
    pathToRegexpOptions: {"strict":true},
    name: "profile-discount-card"
  }, {
    path: "/profile/certificates",
    component: _05f7bf04,
    pathToRegexpOptions: {"strict":true},
    name: "profile-certificates"
  }, {
    path: "/profile/bonuses",
    component: _39609aca,
    pathToRegexpOptions: {"strict":true},
    name: "profile-bonuses"
  }, {
    path: "/profile",
    component: _6f29dc1d,
    pathToRegexpOptions: {"strict":true},
    name: "profile"
  }, {
    path: "/product/test",
    component: _33412d91,
    pathToRegexpOptions: {"strict":true},
    name: "product-test"
  }, {
    path: "/product/glassesCardPage_v2",
    component: _98b44b9e,
    pathToRegexpOptions: {"strict":true},
    name: "product-glassesCardPage_v2"
  }, {
    path: "/product/:slug?",
    component: _4c039e9b,
    pathToRegexpOptions: {"strict":true},
    name: "product-slug"
  }, {
    path: "/order/success/:hash",
    components: {
      default: _11d4cc99
    }
  }, {
    path: "/order/payment/cancel/:hash?",
    component: _b97fd97e,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-cancel-hash"
  }, {
    path: "/order/payment/:hash?",
    component: _bd8e86d8,
    pathToRegexpOptions: {"strict":true},
    name: "order-payment-hash"
  }, {
    path: "/order/:hash",
    components: {
      default: _6963cf63
    }
  }, {
    path: "/ochki/:category",
    component: _4beb8a98,
    pathToRegexpOptions: {"strict":true},
    name: "ochki-category"
  }, {
    path: "/ochki",
    component: _029482e6,
    pathToRegexpOptions: {"strict":true},
    name: "ochki"
  }, {
    path: "/miopiya/indexOriginal",
    component: _d08c648e,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-indexOriginal"
  }, {
    path: "/miopiya/components/QRList",
    component: _213b9224,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-QRList"
  }, {
    path: "/miopiya/components/MiopiyaReasons",
    component: _61ea802a,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaReasons"
  }, {
    path: "/miopiya/components/MiopiyaPrevention",
    component: _5fc0aef6,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya-components-MiopiyaPrevention"
  }, {
    path: "/miopiya",
    component: _7227f048,
    pathToRegexpOptions: {"strict":true},
    name: "miopiya"
  }, {
    path: "/lenses/competitors/:slug?",
    component: _1ea5f5de,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-competitors-slug"
  }, {
    path: "/lenses/:category",
    component: _726f2b48,
    pathToRegexpOptions: {"strict":true},
    name: "lenses-category"
  }, {
    path: "/lenses",
    component: _0bb2a48e,
    pathToRegexpOptions: {"strict":true},
    name: "lenses"
  }, {
    path: "/information_message/informationMessage",
    component: _fe834b56,
    pathToRegexpOptions: {"strict":true},
    name: "information_message-informationMessage"
  }, {
    path: "/get-card",
    component: _064b3e09,
    pathToRegexpOptions: {"strict":true},
    name: "get-card"
  }, {
    path: "/company/questions/page",
    component: _96c4defc,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-page"
  }, {
    path: "/company/questions/letterModal",
    component: _5ff0c3f8,
    pathToRegexpOptions: {"strict":true},
    name: "company-questions-letterModal"
  }, {
    path: "/cms-page-preview",
    component: _73aa2bb0,
    pathToRegexpOptions: {"strict":true},
    name: "cms-page-preview"
  }, {
    path: "/checkout/success",
    component: _11d4cc99,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-success"
  }, {
    path: "/checkout/process/new",
    component: _6c69ad16,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-new"
  }, {
    path: "/checkout/process/:hash",
    component: _6963cf63,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process-hash"
  }, {
    path: "/checkout/process",
    component: _2b0783c8,
    pathToRegexpOptions: {"strict":true},
    name: "checkout-process"
  }, {
    path: "/checkout",
    component: _22367d68,
    pathToRegexpOptions: {"strict":true},
    name: "checkout"
  }, {
    path: "/charity/:category/:article",
    component: _163f78e2,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category-article"
  }, {
    path: "/charity/:category",
    component: _ccc9bccc,
    pathToRegexpOptions: {"strict":true},
    name: "charity-category"
  }, {
    path: "/charity",
    component: _12a7b14c,
    pathToRegexpOptions: {"strict":true},
    name: "charity"
  }, {
    path: "/catalog/components/SelectedFilter",
    component: _907dd132,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-SelectedFilter"
  }, {
    path: "/catalog/components/FilterMobileComponent",
    component: _5e5eed1f,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterMobileComponent"
  }, {
    path: "/catalog/components/FilterComponent",
    component: _570acfa1,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-FilterComponent"
  }, {
    path: "/catalog/components/ContactLinzCategory",
    component: _ca9c16ba,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ContactLinzCategory"
  }, {
    path: "/catalog/components/ArticleCard",
    component: _555731e2,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-components-ArticleCard"
  }, {
    path: "/catalog/*",
    component: _7a6f391a,
    pathToRegexpOptions: {"strict":true},
    name: "catalog-all"
  }, {
    path: "/catalog",
    component: _7f9532e6,
    pathToRegexpOptions: {"strict":true},
    name: "catalog"
  }, {
    path: "/cart_old",
    component: _f2e75e32,
    pathToRegexpOptions: {"strict":true},
    name: "cart_old"
  }, {
    path: "/cart/checkout",
    component: _6a866206,
    pathToRegexpOptions: {"strict":true},
    name: "cart-checkout"
  }, {
    path: "/cart-old/done",
    component: _47495c28,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-done"
  }, {
    path: "/cart-old/basketPageThirdStep",
    component: _7c1b2cb0,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageThirdStep"
  }, {
    path: "/cart-old/basketPageSecondStep",
    component: _288f084a,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old-basketPageSecondStep"
  }, {
    path: "/cart-old",
    component: _124aed1c,
    pathToRegexpOptions: {"strict":true},
    name: "cart-old"
  }, {
    path: "/cart",
    component: _0a16037c,
    pathToRegexpOptions: {"strict":true},
    name: "cart"
  }, {
    path: "/bystraya-zapis",
    component: _e5bcf752,
    pathToRegexpOptions: {"strict":true},
    name: "bystraya-zapis"
  }, {
    path: "/authorization",
    component: _48d4d82d,
    pathToRegexpOptions: {"strict":true},
    name: "authorization"
  }, {
    path: "/appointment/appointment",
    component: _d83dc0c0,
    pathToRegexpOptions: {"strict":true},
    name: "appointment-appointment"
  }, {
    path: "/aktsii/:slug",
    component: _9095c7b4,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii-slug"
  }, {
    path: "/aktsii",
    component: _0e9ced2b,
    pathToRegexpOptions: {"strict":true},
    name: "aktsii"
  }, {
    path: "/acuvue/phoneRegistrationForm",
    component: _654df5e4,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue-phoneRegistrationForm"
  }, {
    path: "/acuvue",
    component: _142d2496,
    pathToRegexpOptions: {"strict":true},
    name: "acuvue"
  }, {
    path: "/*",
    component: _a4fd18e0,
    pathToRegexpOptions: {"strict":true},
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
